import type { Editor } from "@tiptap/core"
import { Selection } from "@tiptap/pm/state"
import type * as filestack from "filestack-js"
import { linkFromUpload } from "../link/link-attrs"

export function prepareFileUploads(files: File[]) {
  return files.map((file) => ({
    file,
    link: linkFromUpload(
      { url: "", filename: file.name, mimetype: file.type, size: file.size },
      "upload",
    ),
  }))
}

export function completeFileUpload(editor: Editor, attachmentId: string, url: string | null) {
  if (editor.isDestroyed) return
  const tr = editor.state.tr
  editor.state.doc.descendants((node, pos) => {
    if (tr.docChanged || node.attrs.attachmentId !== attachmentId) return
    if (url === null) tr.delete(pos, pos + node.nodeSize)
    else tr.setNodeAttribute(pos, "url", url)
    return false
  })
  if (!tr.docChanged) return
  // Updating the URL must not move a gap cursor onto the attachment.
  if (url !== null) tr.setSelection(Selection.fromJSON(tr.doc, editor.state.selection.toJSON()))
  editor.view.dispatch(tr.setMeta("addToHistory", false))
}

export async function uploadFiles(
  editor: Editor,
  client: filestack.Client,
  tasks: ReturnType<typeof prepareFileUploads>,
) {
  await Promise.all(
    tasks.map(async ({ file, link }) => {
      try {
        const result = await client.upload(file)
        completeFileUpload(editor, link.attachmentId, result.url)
      } catch {
        completeFileUpload(editor, link.attachmentId, null)
      }
    }),
  )
}
